import React from 'react';
import { useNavigate } from 'react-router-dom';
import './contactUs.scss';

const ContactUs = () => {
  const navigate = useNavigate();

  return (
    <div className="contactUs">
      <div className="contactUs-content__header">
        <div className="contactUs-content__title d-flex justify-content-center text-center">
          <h2 className="contactUs-title">
            ¿Listo para llevar tu producción <br /> al siguiente nivel?
          </h2>
        </div>
        <div className="contactUs-content__subtitle d-flex justify-content-center text-center">
          <p className="contactUs-content__secondary-title">
            Neuropsicología aplicada a las artes y la producción audiovisual
          </p>
        </div>
        <button className="button-page" onClick={() => navigate('/Contacto')}>
          Contacta
        </button>
      </div>
    </div>
  );
};

export default ContactUs;
